/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BsShopIntegrationData
 */
export interface BsShopIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BsShopIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BsShopIntegrationData
     */
    paused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    databaseName?: string;
    /**
     * 
     * @type {string}
     * @memberof BsShopIntegrationData
     */
    skippedEmailAddressList?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationData
     */
    knownCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationData
     */
    b2cCentres?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BsShopIntegrationData
     */
    b2bCentres?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BsShopIntegrationData
     */
    passwordConfigured?: boolean;
}

/**
 * Check if a given object implements the BsShopIntegrationData interface.
 */
export function instanceOfBsShopIntegrationData(value: object): value is BsShopIntegrationData {
    return true;
}

export function BsShopIntegrationDataFromJSON(json: any): BsShopIntegrationData {
    return BsShopIntegrationDataFromJSONTyped(json, false);
}

export function BsShopIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BsShopIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] === undefined ? undefined : json['lastRegularUpdate'] === null ? null : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] === undefined ? undefined : json['lastHistoricalUpdate'] === null ? null : json['lastHistoricalUpdate'],
        'paused': json['paused'] == null ? undefined : json['paused'],
        'project': json['project'] == null ? undefined : json['project'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'port': json['port'] == null ? undefined : json['port'],
        'username': json['username'] == null ? undefined : json['username'],
        'databaseName': json['databaseName'] == null ? undefined : json['databaseName'],
        'skippedEmailAddressList': json['skippedEmailAddressList'] == null ? undefined : json['skippedEmailAddressList'],
        'knownCentres': json['knownCentres'] == null ? undefined : json['knownCentres'],
        'b2cCentres': json['b2cCentres'] == null ? undefined : json['b2cCentres'],
        'b2bCentres': json['b2bCentres'] == null ? undefined : json['b2bCentres'],
        'passwordConfigured': json['passwordConfigured'] == null ? undefined : json['passwordConfigured'],
    };
}

export function BsShopIntegrationDataToJSON(json: any): BsShopIntegrationData {
    return BsShopIntegrationDataToJSONTyped(json, false);
}

export function BsShopIntegrationDataToJSONTyped(value?: BsShopIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'paused': value['paused'],
        'project': value['project'],
        'hostname': value['hostname'],
        'port': value['port'],
        'username': value['username'],
        'databaseName': value['databaseName'],
        'skippedEmailAddressList': value['skippedEmailAddressList'],
        'knownCentres': value['knownCentres'],
        'b2cCentres': value['b2cCentres'],
        'b2bCentres': value['b2bCentres'],
        'passwordConfigured': value['passwordConfigured'],
    };
}

